export default "__VITE_ASSET__9a582950__"